import MenuItemBody, { MenuItemBodyProps } from './MenuItemBody';

export type { MenuItemBodyProps };
export default MenuItemBody;
